// In-memory staging area for the two-step upload flow (media → smart form).
// File objects can't be passed via react-router state safely, so we keep them
// here. Cleared after submit or when the user navigates away from /upload.

import type { Company, VehicleType } from '@/api/types';

interface Draft {
  files: File[];
  company?: Company;
  vehicleType?: VehicleType;
  city?: string;
  district?: string;
  longestTripKm?: number;
  type?: 'DAILY' | 'HISTORICAL';
  shiftDate?: string;
}

let draft: Draft = { files: [] };

export const uploadDraft = {
  get(): Draft { return draft; },
  setFiles(files: File[]) { draft = { ...draft, files }; },
  update(patch: Partial<Draft>) { draft = { ...draft, ...patch }; },
  clear() { draft = { files: [] }; },
};
